import { state, style, trigger } from '@angular/animations';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { HolidayGroup } from '@classes/holiday/holiday-group';
import { DatatableBaseComponent } from '@components/datatable-base.component';
import { HolidayGroupsService } from '@services/holiday-groups.service';
import { UiService } from '@services/ui.service';

@Component({
  selector: 'app-holiday-groups',
  templateUrl: './holiday-groups.component.html',
  styleUrls: ['./holiday-groups.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' }))
    ])
  ]
})
export class HolidayGroupsComponent extends DatatableBaseComponent implements OnInit {
  holidayGroups: HolidayGroup[];

  isLoading = false;

  dataSource: MatTableDataSource<HolidayGroup>;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  displayedColumns = ['name', 'actions'];

  constructor(
    protected uiSrv: UiService,
    private route: ActivatedRoute,
    private holidayGroupsSrv: HolidayGroupsService
  ) {
    super(uiSrv);
   }

  ngOnInit(): void {
    this.getRouteData();
    this.initSub();
  }

  private getRouteData(): void {
    this.route.data
      .subscribe((data: { holidayGroups: any[] }) => {
        this.holidayGroups = data.holidayGroups;
        this.initTable();
      });
  }

  initSub() {
    this.addSubscription(
      this.holidayGroupsSrv.holidayGroupsListChanged
        .subscribe(holidayGroups => {
          this.dataSource.data = holidayGroups || [];
          this.dataSource.sort = this.sort;
          this.onEditFinished();
        })
    );
  }

  private initTable(): void {
    this.dataSource = new MatTableDataSource(this.holidayGroups);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;

  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  delete(idHolidayGroup: string) {
    const confirmation = confirm('Êtes-vous certain de vouloir supprimer ce groupe de jours fériés ?');

    if (confirmation) {
      this.holidayGroupsSrv.delete(idHolidayGroup).subscribe(() => {
        this.uiSrv.showSnackbar('billing.holidays.list.deleted', true);
      });
    }
  }
}
